import { render } from "./Integer.vue?vue&type=template&id=6b798b09&lang=pug"
import script from "./Integer.vue?vue&type=script&lang=ts"
export * from "./Integer.vue?vue&type=script&lang=ts"
script.render = render

export default script